// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UmW2","left":"styles_left__gMfZw"};